import { debounce } from 'lodash-es';

export default {
  methods: {
    ui_showFooter(value) {
      this.$store.dispatch('ui/setValue', { showFooter: value });
    },
    ui_accountModal({ type, value, action = null }) {
      this.$store.dispatch('ui/showModalAccount', { value, type });
      this.$store.dispatch('ui/setValue', { accountComponentAction: action });
      this.$store.dispatch('ui/showModal', value);
      return Promise.resolve();
    },
    ui_showModal(value) {
      this.$store.dispatch('ui/showModal', value);
    },
    ui_showModalPassword() {
      this.$store.dispatch('ui/showModalPassword');
    },
    ui_showModalBankAccount() {
      this.$store.dispatch('ui/showModalBankAccount');
    },
    ui_showModalDeleteAccount() {
      this.$store.dispatch('ui/showModalDeleteAccount');
    },
    ui_showModalComplementaryInfo() {
      this.$store.dispatch('ui/showModalComplementaryInfo');
    },
    ui_showFeedbackModal() {
      this.$store.dispatch('ui/showModalFeedback');
    },
    ui_showModalCrossSell({ type, value, cancel }) {
      this.$store.dispatch('ui/showModalCrossSell', { value, type, cancel });
    },
    ui_showModalSchedule(value) {
      this.$store.dispatch('ui/showModalSchedule', value);
    },
    ui_showModalAmendment(type, value) {
      this.$store.dispatch('ui/showModalAmendment', { value, type });
    },
    ui_showMenu(value) {
      this.$store.dispatch('ui/setValue', { isToolBarOpen: value });
      this.$store.dispatch('ui/setValue', { isToolBarMobileOpen: value });
      this.$store.dispatch('ui/setValue', { showMenu: value });
    },
    ui_focusScreen(value) {
      if (!value) {
        const setValue = () => {
          this.$store.dispatch('ui/focusScreen', value);
        };
        this.debouncer = debounce(setValue, 600);
        this.debouncer();
      } else this.$store.dispatch('ui/focusScreen', value);
    },
    ui_showToast(object) {
      return new Promise((resolve, reject) => {
        if (object.show) {
          this.$store.dispatch('ui/showToast', object).then(() => {
            setTimeout(() => {
              this.$store.dispatch('ui/showToast', { show: false });
              resolve();
            }, 6000);
          })
            .then(resolve)
            .catch(reject);
        } else { resolve() }
      });
    },
    ui_showPlaceholder() {
      const setValue = () => {
        this.isLoading = false;
      };
      this.debouncer = debounce(setValue, 800);
      this.debouncer();
    },
  },
};
